module.exports = __webpack_public_path__ + "img/single-vel-info3.e6d57bcd.png";